'use client'

import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'

export function CarbonMotionBoundary({ children }: { children: ReactNode }) {
  const pathname = usePathname()

  return (
    <div key={pathname} className="carbon-motion-page">
      {children}
    </div>
  )
}
